import React, { useEffect, useRef, useState } from "react";
import Map, {
  FullscreenControl,
  Layer,
  Marker,
  NavigationControl,
  ScaleControl,
  Source,
  useControl,
} from "react-map-gl/mapbox";
import "mapbox-gl/dist/mapbox-gl.css";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import GpsPositionMarker from "../components/GPSPositionMarker";
import * as turf from "@turf/turf";
import {
  getGpsGateGeofences,
  getGpsGateTrackerUser,
  getGpsGateUser,
  gpsUpdateGeoGroup,
} from "../utils/apiGpsGate.utils";
import GpsPositionTrack from "../components/GpsPositionTrack";
import GpsPolygon from "../components/GpsPolygon";
import GpsCircle from "../components/GpsCircle";
import MapGeofenceModal from "../components/MapGeofenceModal";
import MapEditGeofenceModal from "../components/MapEditGeofenceModal";
import DataTable from "react-data-table-component";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { transformSelectFormat } from "../utils/transformFormatSelect";
import VirtualizedTable from "../components/VirtualizedTable";
import GPSTrackPositionMarker from "../components/GPSTrackPositionMarker";
import Swal from "sweetalert2";
import { actualTumSimberi } from "../services/tumApi";
import eyeOpen from "../assets/iconMenu/eyeOpen.svg";
import eyeClose from "../assets/iconMenu/eyeClose.svg";
import TrackReplaySVGTrack from "../components/TrackReplaySVGTrack";
import TrackReplaySVGTum from "../components/TrackReplaySVGTum";
import GpsPositionTrackUnix from "../components/GpsPositionTrackUnix";
import EquipmentTable from "../components/EquipmentTable";

const MainMapContainer = ({
  showGeofenceInfo,
  showEquipmentInfo,
  applicationInfo,
  isFooterOpen,
  isOpenSidebar,
}) => {
  const mapRef = useRef();
  const drawRef = useRef(null);

  //ZOOM
  const [initialPosition, setInitialPosition] = useState({
    latitude: applicationInfo?.app_gps_lat,
    longitude: applicationInfo?.app_gps_lon,
    zoom: 14,
  });
  const [actualInfoGps, setActualInfoGps] = useState([]);
  const [trackpointInfoGps, setTrackpointInfoGps] = useState([]);
  const [geofenceList, setGeofenceList] = useState([]);
  const [geofenceSelectList, setGeofenceSelectList] = useState([]);
  const [newGeofencePolygon, setNewGeofencePolygon] = useState(null);

  const [geofenceEditPolygonInfo, setGeofenceEditPolygonInfo] = useState(null);
  const [geofenceRefreshIcon, setgeofenceRefreshIcon] = useState(false);
  const [trackReplayRefreshIcon, setTrackReplayRefreshIcon] = useState(false);

  const [showModalGeofences, setShowModalGeofences] = useState(false);
  const [showModalEditGeofences, setShowModalEditGeofences] = useState(false);
  const [isDrawLoaded, setIsDrawLoaded] = useState(false);
  const [flagRefreshGeofences, setFlagRefreshGeofences] = useState(true);

  const [trackReplayEquipmentList, setTrackReplayEquipmentList] = useState([]);
  const [trackReplayEquipmentSelected, setTrackReplayEquipmentSelected] =
    useState(null);
  const [trackReplayStartDate, setTrackReplayStartDate] = useState(null);
  const [trackReplayEndDate, setTrackReplayEndDate] = useState(null);
  const [trackReplayShowReplay, setTrackReplayShowReplay] = useState(true);
  const [trackReplayShowTable, setTrackReplayShowTable] = useState(false);
  const [trackReplayShowTum, setTrackReplayShowTum] = useState(false);
  const [trackReplayShowMarkerReplay, setTrackReplayShowMarkerReplay] =
    useState(true);
  const [trackReplayShowEquipmentMap, setTrackReplayShowEquipmentMap] =
    useState(true);

  const [trackReplayTableMarker, setTrackReplayTableMarker] = useState(null);
  const [trackReplayTableInfo, setTrackReplayTableInfo] = useState(null);

  const [TRActionMinimize, setTRActionMinimize] = useState(false);
  const [TRActionActualPoint, setTRActionActualPoint] = useState(0);
  const [TRActionActualTime, setTRActionActualTime] = useState("");
  const [TRActionActualTimeUnix, setTRActionActualTimeUnix] = useState();
  const [TRActionActualTimeUnixString, setTRActionActualTimeUnixString] =
    useState("");
  const [TRActionPlay, setTRActionPlay] = useState(false);
  const [TRActionSelectListSpeed, setTRActionSelectListSpeed] = useState([
    { value: 1, label: "x 1 sec" },
    { value: 60, label: "x 1 min" },
    { value: 300, label: "x 5 min" },
    { value: 600, label: "x 10 min" },
  ]);
  const [TRActionSelectedSpeed, setTRActionSelectedSpeed] = useState({
    value: 1,
    label: "x 1 sec",
  });

  const [TRTimelineTracks, setTRTimelineTracks] = useState([]);
  const [TRTimelineTum, setTRTimelineTum] = useState(null);
  const [TRTimelineInitialDate, setTRTimelineInitialDate] = useState(null);
  const [TRTimelineEndDate, setTRTimelineEndDate] = useState(null);
  const [TRTimelineInitialDateUnix, setTRTimelineInitialDateUnix] =
    useState(null);
  const [TRTimelineEndDateUnix, setTRTimelineEndDateUnix] = useState(null);
  const [TRTimelinePositionRec, setTRTimelinePositionRec] = useState({
    xPos: 9,
    with: 2,
    height: 150,
  });

  const [TRTimelineTracksTooltip, setTRTimelineTracksTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    status: "",
    initialDatetime: "",
    endDatetime: "",
    duration: "",
  });

  const [TRTimelineTumTooltip, setTRTimelineTumTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    status: "",
    category: "",
    subCategory: "",
    reason: "",
    initialDatetime: "",
    endDatetime: "",
    duration: "",
  });

  const TRActionDivRefSvg = useRef(null);
  const [TRActionDivRefSvgSize, setTRActionDivRefSvgSize] = useState({
    width: 0,
    height: 0,
  });

  const [testSSEback, setTestSSEback] = useState();

  const [mapControlType, setmapControlType] = useState({
    label: "Satellite",
    value: "mapbox://styles/mapbox/satellite-v9",
  });

  const [mapControlLabels, setmapControlLabels] = useState(true);

  const mapboxStyles = [
    { label: "Streets", value: "mapbox://styles/mapbox/streets-v12" },
    { label: "Satellite", value: "mapbox://styles/mapbox/satellite-v9" },
    { label: "Outdoors", value: "mapbox://styles/mapbox/outdoors-v12" },
    { label: "Dark", value: "mapbox://styles/mapbox/dark-v11" },
    { label: "Light", value: "mapbox://styles/mapbox/light-v11" },
  ];

  const labelGeofenceStyle = [
    { label: "Show Label", value: true },
    { label: "Hidden Label", value: false },
  ];

  let columns = [
    {
      name: "Status",
      sortable: true,
      width: "58px",
      minWidth: "58px",
      cell: (row) => {
        let statusIcon;
        switch (row.statusEquipment) {
          case 1:
            statusIcon = "🟢"; // encendido, movimiento y speed
            break;
          case 2:
            statusIcon = "🟡"; // encendido pero sin movimiento
            break;
          case 3:
            statusIcon = "🔴"; // apagado
            break;
          case 4:
            statusIcon = "🔵"; // encendido, movimiento y sin speed
            break;
          case 5:
            statusIcon = "⚪"; // encendido, movimiento y sin speed
            break;
          default:
            statusIcon = "⚪"; // desconocido
        }
        return <div className="text-center">{statusIcon}</div>;
      },
    },
    {
      name: "Equipment",
      selector: (row) => row.name,
      sortable: true,
      minWidth: "82px",
    },
    {
      name: "Type",
      selector: (row) => row.typeEquipment,
      sortable: true,
      minWidth: "73px",
    },
    {
      name: "Last Seen",
      selector: (row) => (row.errorDatetime == true ? "-" : row.utcDatetime),
      sortable: true,
      width: "98px",
      minWidth: "88px",
      cell: (row) => (
        <div
          className="truncate max-w-[150px]"
          title={row.errorDatetime == true ? "-" : row.utcDatetime}
        >
          {row.errorDatetime == true ? "-" : row.utcHourDatetime}
        </div>
      ),
    },
    {
      name: "Last Connection",
      selector: (row) =>
        row.errorDatetime == true ? "-" : row.deviceActivityDatetime,
      sortable: true,
      width: "98px",
      minWidth: "98px",
      cell: (row) => (
        <div
          className="truncate max-w-[150px]"
          title={row.errorDatetime == true ? "-" : row.deviceActivityDatetime}
        >
          {row.errorDatetime == true ? "-" : row.deviceActivityHourDatetime}
        </div>
      ),
    },
    {
      name: "Speed",
      width: "70px",
      minWidth: "70px",
      selector: (row) => {
        if (row.statusEquipment === 5) return "-";
        const speedEquipment = row.velocity.groundSpeed;

        if (applicationInfo?.app_unit === "imperial") {
          // 1 m/s = 2.23694 mi/h
          return Math.round(speedEquipment * 2.237) + " mi/h";
        } else {
          // 1 m/s = 3.6 km/h
          return Math.round(speedEquipment * 3.6) + " km/h";
        }
      },
      sortable: true,
    },
    {
      name: "Driver",
      selector: (row) => row?.variables?.Operator?.value,
      sortable: true,
      minWidth: "73px",
    },
  ];

  const customStyles = {
    rows: {
      style: {
        fontSize: "9px",
        backgroundColor: "#D1D5DB",
      },
    },
    headCells: {
      style: {
        fontSize: "9px",
        backgroundColor: "#D1D5DB",
      },
    },
    cells: {
      style: {
        border: "1px solid #f3f4f6", // borde inferior de celdas, color blanco grisáceo
      },
    },
  };

  const customStylesSelectTrackReplay = {
    control: (base) => ({
      ...base,
      minHeight: "30px",
      height: "30px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 1px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "30px",
    }),

    multiValueLabel: (base) => ({
      ...base,
      fontSize: "8px", // 🔹 tamaño del texto
      padding: "0 4px",
      maxWidth: "35px",
    }),

    multiValue: (base) => ({
      ...base,
      fontSize: "5px",
      padding: "0px",
      color: "red",
    }),
  };

  const playRef = useRef(TRActionPlay);
  const speedRef = useRef(TRActionSelectedSpeed.value);
  const rafRef = useRef(null);
  const lastTimeRef = useRef(0);
  const accRef = useRef(0);

  useEffect(() => {
    playRef.current = TRActionPlay;
  }, [TRActionPlay]);

  useEffect(() => {
    speedRef.current = TRActionSelectedSpeed.value;
  }, [TRActionSelectedSpeed]);

  useEffect(() => {
    if (!TRActionPlay) {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      return;
    }

    //guarda el ultimo tiempo en milisegundos que se cargo la pagina
    lastTimeRef.current = performance.now();
    accRef.current = 0;

    const loop = (now) => {
      if (!playRef.current) return;

      //Se guarda el tiempo acumulado cuando se va cambiando de frame
      const delta = now - lastTimeRef.current;
      lastTimeRef.current = now;
      accRef.current += delta;

      //Calcula en milisegundos la velocidad que se asigna en speed
      const stepMs = 1000 / speedRef.current;

      while (accRef.current >= stepMs) {
        accRef.current -= stepMs;

        setTRActionActualTimeUnix((prev) => {
          if (prev >= TRTimelineEndDateUnix) {
            playRef.current = false;
            setTRActionPlay(false);
            return prev;
          }
          return prev + 1000;
        });
      }

      rafRef.current = requestAnimationFrame(loop);
    };

    rafRef.current = requestAnimationFrame(loop);

    return () => cancelAnimationFrame(rafRef.current);
  }, [TRActionPlay, TRTimelineEndDateUnix]);

  useEffect(() => {
    if (!TRActionActualTimeUnix) return;
    const date = new Date(TRActionActualTimeUnix);
    const formatted = date.toLocaleTimeString("es-CL", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    setTRActionActualTimeUnixString(formatted);

    var dataPosition = transformTimelineData(
      9,
      TRActionDivRefSvgSize.width,
      TRTimelineInitialDateUnix,
      TRTimelineEndDateUnix,
      TRActionActualTimeUnix,
      TRActionActualTimeUnix,
    );

    if (dataPosition.pixelPosition <= TRTimelineEndDateUnix) {
      setTRTimelinePositionRec({
        xPos: dataPosition.pixelPosition,
        with: 2,
        height: 150,
      });
    }
  }, [TRActionActualTimeUnix]);

  useEffect(() => {
    const element = TRActionDivRefSvg.current;
    if (!element) return;

    const measure = () => {
      const rect = element.getBoundingClientRect();
      setTRActionDivRefSvgSize({ width: rect.width, height: rect.height });
    };

    // Espera un frame para que el layout esté listo
    requestAnimationFrame(measure);

    // Escucha futuros cambios de tamaño
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        const { width, height } = entry.contentRect;
        setTRActionDivRefSvgSize({ width, height });
      }
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, [
    trackReplayShowReplay,
    trackpointInfoGps,
    TRActionMinimize,
    showEquipmentInfo,
  ]);

  useEffect(() => {
    fetchGpsUser();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchGpsUser();
    }, 15000); // 15000 ms = 15 segundos
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchGeofenceInfo();
  }, [flagRefreshGeofences]);

  useEffect(() => {
    if (!mapRef.current) return;

    const map = mapRef.current.getMap();

    // inicializar draw
    if (!drawRef.current) {
      drawRef.current = new MapboxDraw({
        displayControlsDefault: false,
      });

      map.addControl(drawRef.current);
      setIsDrawLoaded(true);

      // evento: cuando se crea un polígono
      map.on("draw.create", updateFeatures);
      // evento: cuando se actualiza un polígono
      map.on("draw.update", updateFeatures);
      // evento: cuando se borra un polígono
      map.on("draw.delete", updateFeatures);
    }
    return () => {
      if (map && drawRef.current) {
        map.off("draw.create", updateFeatures);
        map.off("draw.update", updateFeatures);
        map.off("draw.delete", updateFeatures);
        map.removeControl(drawRef.current);
        drawRef.current = null;
      }
    };
  }, [mapRef.current]);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.getMap().resize();
    }
  }, [showEquipmentInfo, showGeofenceInfo]);

  useEffect(() => {
    if (mapRef.current) {
      const timer = setTimeout(() => {
        mapRef.current.getMap().resize();
        //console.log("Map resized!");
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isOpenSidebar]);

  const updateFeatures = () => {
    const data = drawRef.current.getAll();
    setNewGeofencePolygon(data.features);
  };

  const handleTrackReplayButtom = () => {
    setTrackReplayShowReplay(true);
    setTrackReplayShowMarkerReplay(true);
    setTrackReplayShowTable(false);
    setTrackReplayShowTum(false);
    setTrackReplayTableMarker(null);
  };

  const handleTrackPointButtom = () => {
    if (trackpointInfoGps?.length > 0) {
      setTrackReplayShowTable(true);
      setTrackReplayShowMarkerReplay(false);
      setTrackReplayShowReplay(false);
      setTrackReplayShowTum(false);
      setTRActionPlay(false);
    }
  };

  const handleTumButtom = () => {
    if (trackpointInfoGps?.length > 0) {
      setTrackReplayShowTable(false);
      setTrackReplayShowReplay(false);
      setTrackReplayShowMarkerReplay(false);
      setTrackReplayShowTum(true);
      setTRActionPlay(false);
      setTrackReplayTableMarker(null);
    }
  };

  const cleanReplayInfo = () => {
    setTrackReplayTableMarker(null);
    setTrackpointInfoGps([]);
    setTRActionActualPoint(0);
    setTRActionActualTime("");
    setTRActionActualTimeUnix(0);
    setTRActionActualTimeUnix("");
    setTrackReplayShowReplay(true);
    setTrackReplayShowTable(false);
    setTrackReplayShowTum(false);
    setTrackReplayEquipmentSelected(null);
    setTrackReplayShowMarkerReplay(true);
    setTRActionActualTimeUnixString(null);
    setTRTimelineInitialDateUnix(0);
    setTRTimelineEndDateUnix(0);
  };

  const joinReplayTableInfo = (replayInfo) => {
    //console.log("Logs Track Replay Join", replayInfo);

    for (var i = 0; i < replayInfo.length; i++) {
      //console.log("Logs Track Replay Join Bucle", replayInfo[i]?.trackPoint);
    }
    const mergedAndSorted = replayInfo
      .flatMap((c) => c?.trackPoint)
      .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
    //console.log("Logs Track Replay Join merge", mergedAndSorted);

    setTrackReplayTableInfo(mergedAndSorted);
  };

  const fetchTrackerInfo = async () => {
    setTrackReplayRefreshIcon(true);
    setTrackReplayTableMarker(null);
    setTrackpointInfoGps([]);
    setTRActionActualPoint(0);
    setTRActionActualTime("");
    setTRActionActualTimeUnixString(null);
    setTRActionActualTimeUnix(0);
    setTRTimelineInitialDateUnix(0);
    setTRTimelineEndDateUnix(0);
    setTRActionActualTimeUnix("");

    //console.log(trackReplayStartDate);
    //console.log(trackReplayEndDate);
    if (
      trackReplayStartDate &&
      trackReplayEndDate &&
      trackReplayEquipmentSelected
    ) {
      //console.log("trackReplayControl tiene datos");
      //console.log('Proceso fechas', trackReplayStartDate.getDate())
      //console.log('Proceso fechas', trackReplayEndDate.getDate())
      var initialDay = trackReplayStartDate.getDate();
      var endDay = trackReplayEndDate.getDate();
      var diff = endDay - initialDay;

      var isTwoDays = false;
      if (
        (diff >= 0 && diff <= 1) ||
        (initialDay == 30 && endDay == 1) ||
        (initialDay == 31 && endDay == 1)
      ) {
        isTwoDays = true;
      }

      //console.log('Proceso fechas D', diff)
      //console.log('Proceso fechas D', isTwoDays)
      if (trackReplayEndDate > trackReplayStartDate && isTwoDays) {
        const equipment_track = await getGpsGateTrackerUser(
          applicationInfo?.app_gps_id,
          applicationInfo?.application_gmt,
          trackReplayEquipmentSelected,
          trackReplayStartDate,
          trackReplayEndDate,
          applicationInfo?.app_has_tum_replay,
          applicationInfo?.app_backend_route,
          applicationInfo?.app_unit,
          isTwoDays,
        );
        //console.log("Logs Track Replay Main ", equipment_track);
        joinReplayTableInfo(equipment_track.tracks);
        //console.log("Listado Estados Sumarizados ", equipment_track?.tum_timeline);
        //console.log("Listado Estados Sumarizados:", equipment_track?.track_timeline);
        setTrackpointInfoGps(equipment_track?.tracks);
        setTRTimelineTum(equipment_track?.tracks[0].tum_timeline);
        setTRTimelineTracks(equipment_track?.tracks);
        setTRTimelineInitialDate(equipment_track?.initial_limit);
        setTRTimelineInitialDateUnix(equipment_track?.initial_limitUnix);
        setTRActionActualTimeUnix(
          new Date(equipment_track?.initial_limit).getTime(),
        );
        setTRTimelineEndDate(equipment_track?.end_limit);
        setTRTimelineEndDateUnix(equipment_track?.end_limitUnix);
        setTrackReplayTableMarker(null);
      } else {
        let result_error = await Swal.fire({
          title: "Invalid Dates",
          icon: "error",
          text: "The start date must be earlier than the end date. They must also fall on the same day.",
          confirmButtonColor: "#3085d6",
          customClass: {
            confirmButton:
              "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
          },
          buttonsStyling: false,
        });
      }
    } else {
      let result_error = await Swal.fire({
        title: "Incomplete fields",
        icon: "error",
        text: "There are fields that are mandatory",
        confirmButtonColor: "#3085d6",
        customClass: {
          confirmButton:
            "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
        },
        buttonsStyling: false,
      });
    }
    setTrackReplayRefreshIcon(false);
  };

  const fetchGpsUser = async () => {
    const equipment_info = await getGpsGateUser(
      applicationInfo?.app_gps_id,
      applicationInfo?.application_gmt,
    );
    //console.log("Listado equipos ", equipment_info);
    if (equipment_info && equipment_info.length > 0) {
      setActualInfoGps(equipment_info);
      //console.log('LOG OPERATOR M VAR', equipment_info)
      //console.log('LOG OPERATOR VAR', equipment_info[0].variables?.Operator?.value)
    }

    const truck_select_aux = equipment_info.filter(
      (equipo) =>
        equipo.typeEquipment === "Truck" || equipo.typeEquipment === "Camion",
    );
    const shovel_select_aux = equipment_info.filter(
      (equipo) =>
        equipo.typeEquipment === "Shovel" || equipo.typeEquipment === "Pala",
    );

    const dozer_select_aux = equipment_info.filter(
      (equipo) => equipo.typeEquipment === "Dozer",
    );
    const grader_select_aux = equipment_info.filter(
      (equipo) => equipo.typeEquipment === "Grader",
    );

    const select_equipment_truck_list = transformSelectFormat(
      truck_select_aux,
      "id",
      "name",
    );
    const select_equipment_shovel_list = transformSelectFormat(
      shovel_select_aux,
      "id",
      "name",
    );

    const select_equipment_dozer_list = transformSelectFormat(
      dozer_select_aux,
      "id",
      "name",
    );

    const select_equipment_grader_list = transformSelectFormat(
      grader_select_aux,
      "id",
      "name",
    );

    if (
      select_equipment_truck_list.status == 200 ||
      select_equipment_shovel_list == 200 ||
      select_equipment_dozer_list == 200 ||
      select_equipment_grader_list == 200
    ) {
      if (trackReplayEquipmentList.length == 0) {
        //console.log('La lista es ', equipment_info)
        //console.log("La lista es ", select_equipment_list.data);
        var equipment_truck_list = select_equipment_truck_list.data;
        equipment_truck_list.sort(
          (a, b) => a.label.replace(/\D/g, "") - b.label.replace(/\D/g, ""),
        );

        var equipment_shovel_list = select_equipment_shovel_list.data;
        equipment_shovel_list.sort(
          (a, b) => a.label.replace(/\D/g, "") - b.label.replace(/\D/g, ""),
        );

        var equipment_dozer_list = select_equipment_dozer_list.data;
        equipment_dozer_list.sort(
          (a, b) => a.label.replace(/\D/g, "") - b.label.replace(/\D/g, ""),
        );

        var equipment_grader_list = select_equipment_grader_list.data;
        equipment_grader_list.sort(
          (a, b) => a.label.replace(/\D/g, "") - b.label.replace(/\D/g, ""),
        );

        var all_equipment_list = [
          ...equipment_truck_list,
          ...equipment_shovel_list,
          ...equipment_dozer_list,
          ...equipment_grader_list,
        ];
        setTrackReplayEquipmentList(all_equipment_list);
      }
    }
  };

  const fetchTumUser = async () => {
    const tumInfo = await actualTumSimberi();
    //console.log("El tum es: ", tumInfo);
  };

  const fetchGeofenceInfo = async () => {
    setgeofenceRefreshIcon(true);
    const result_geofences = await getGpsGateGeofences(
      applicationInfo?.app_gps_id,
    );
    if (result_geofences.status == 200) {
      setGeofenceList(result_geofences.geofenceList);
      setGeofenceSelectList(result_geofences.geoGroupSelect);
    }
    setgeofenceRefreshIcon(false);
  };

  const GeofenceClick = (e, geofence, geo_group, zoom) => {
    var longitude = null;
    var latitude = null;
    var position_polygon = geofence?.vertices;
    var position_circle = geofence?.circleConfig;

    var geofenceId = geofence.id;
    var geofenceName = geofence.name;
    var geofenceDescription = geofence.description;
    var geofenceVertices = geofence.vertices;
    var geoGroupId = geo_group.groupId;
    var geoGroupName = geo_group.groupName;

    if (geofence.type == "Polygon") {
      console.log("El poligono es: ", position_polygon);
      var ringCentroid = position_polygon.map((v) => [
        Number(v.longitude),
        Number(v.latitude),
      ]);

      var polygonCrentroid = {
        type: "Feature",
        properties: {},
        geometry: {
          type: "Polygon",
          coordinates: [ringCentroid],
        },
      };

      console.log("El poligono es: ", polygonCrentroid);
      const centroidGeofence = turf.centroid(polygonCrentroid);
      console.log("El poligono es: ", centroidGeofence);

      longitude = centroidGeofence.geometry.coordinates[0];
      latitude = centroidGeofence.geometry.coordinates[1];
    } else if (geofence.type == "Circle") {
      longitude = position_circle.center.longitude;
      latitude = position_circle.center.latitude;
    } else {
      return null;
    }

    mapRef.current?.flyTo({
      center: [longitude, latitude],
      zoom,
      duration: 2000,
    });

    if (e.type === "click") {
      var auxLeft = true;
    } else if (e.type === "contextmenu" && geofence.type == "Polygon") {
      setGeofenceEditPolygonInfo({
        selectedGeoGroup: { value: geoGroupId, label: geoGroupName },
        geofenceId: geofenceId,
        geofenceName: geofenceName,
        vertices: geofenceVertices,
        description: geofenceDescription,
      });
      activeEditGeofence();
    }
  };

  const equipmentClick = (rowEquipmentInfo) => {
    var latitude = null;
    var longitude = null;
    var zoom = 15;
    var gpsInfo = rowEquipmentInfo?.original;
    console.log("LOG OPERATOR TABLE: ", gpsInfo);

    if (gpsInfo?.errorDatetime == false) {
      console.log("LOG OPERATOR TABLE: jeje");
      latitude = gpsInfo.trackPoint.latitude;
      longitude = gpsInfo.trackPoint.longitude;
      mapRef.current?.flyTo({
        center: [longitude, latitude],
        zoom,
        duration: 2000,
      });
    }
  };

  const activeNewGeofence = () => {
    drawRef.current.changeMode("draw_polygon");
    setShowModalGeofences(true);
  };

  const activeEditGeofence = () => {
    setShowModalEditGeofences(false);
    setShowModalEditGeofences(true);
  };

  const trackReplayInicioButton = () => {
    setTRActionActualTimeUnix(TRTimelineInitialDateUnix);
    setTRActionPlay(false);
  };

  const trackReplayEndButton = () => {
    setTRActionActualTimeUnix(TRTimelineEndDateUnix);
    setTRActionPlay(false);
  };

  const trackReplayPlayButton = () => {
    //console.log(TRActionActualPoint);
    //console.log(TRActionPlay);
    setTRActionPlay(!TRActionPlay);
  };

  const trackReplayForwardButton = () => {
    if (!trackpointInfoGps?.length) return;
    setTRActionActualTimeUnix((prev) => {
      if (prev >= TRTimelineEndDateUnix) {
        setTRActionPlay(false);
        return prev; // NO sigas sumando
      }
      return prev + 1000;
    });
  };

  const trackReplayBackwardButton = () => {
    if (!trackpointInfoGps?.length) return;
    setTRActionActualTimeUnix((prev) => {
      if (prev <= TRTimelineInitialDateUnix) {
        setTRActionPlay(false);
        return prev; // NO sigas sumando
      }
      return prev - 1000;
    });
  };

  const trackReplaySliderTimeline = (e) => {
    if (!trackpointInfoGps?.length) return;

    const newIndex = Number(e.target.value);
    setTRActionPlay(false);
    setTRActionActualPoint(newIndex);

    const auxTime = trackpointInfoGps[0].trackPoint[newIndex].timestamp;
    setTRActionActualTime(auxTime.slice(11, 16));

    //console.log("El tamaño actual de la ventana es:", TRActionDivRefSvgSize);
  };

  const trackReplaySliderByTime = (e) => {
    setTRActionPlay(false);
    const newIndex = Number(e.target.value);
    const dateObject = new Date(newIndex);
    const time = dateObject.toLocaleTimeString("es-CL", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    //console.log('Logs Track Replay Slider ', dateObject.toString());

    setTRActionActualTimeUnix(newIndex);
    setTRActionActualTimeUnixString(time);

    //console.log("El tamaño actual de la ventana es:", TRActionDivRefSvgSize);
  };

  const handleMinimizeTrackReplay = () => {
    setTRActionMinimize(!TRActionMinimize);
  };

  const UpdateVisibilityGeoGroup = async (geoGroup) => {
    let bodyGeoGroupUpdate = {
      colour: geoGroup.colour,
      description: geoGroup.description,
      geofenceIds: geoGroup.geofenceIds,
      id: geoGroup.groupId,
      name: geoGroup.groupName,
      pinned: !geoGroup.isVisible,
      priority: geoGroup.priority,
      useInGeocoding: geoGroup.useInGeocoding,
    };
    setgeofenceRefreshIcon(true);
    const result_update = await gpsUpdateGeoGroup(
      applicationInfo?.app_gps_id,
      bodyGeoGroupUpdate,
    );

    if (result_update.status == 200) {
      //console.log("Se cambia la visibilidad 3: ", result_update.status);
      setFlagRefreshGeofences(!flagRefreshGeofences);
    }
  };

  const checkZinDateString = (datetimeString) => {
    const haveZ = datetimeString.endsWith("Z") || datetimeString.endsWith("z");
    if (!haveZ) {
      return datetimeString + "Z";
    }
    return datetimeString;
  };

  const transformTimelineData = (
    pMin,
    pMax,
    tMin,
    tMax,
    actualTimeStart,
    actualTimeEnd,
  ) => {
    //console.log('Logs Track Replay Trans 1', tMin);
    //console.log('Logs Track Replay Trans 2', tMax);
    //console.log('Logs Track Replay Trans 3', actualTimeStart);
    //console.log('Logs Track Replay Trans 4', actualTimeEnd);
    //console.log('Listado Estados Sumarizados  - funcion');
    var tNumStart = actualTimeStart - tMin;
    var tDenStart = tMax - tMin;
    var tDivStart = tNumStart / tDenStart;
    var actualPixelStart = pMin + tDivStart * (pMax - pMin);
    //console.log('Listado Estados Sumarizados  - funcion pixel start: ', actualPixelStart);

    var tNumEnd = actualTimeEnd - tMin;
    var tDenEnd = tMax - tMin;
    var tDivEnd = tNumEnd / tDenEnd;
    var actualPixelEnd = pMin + tDivEnd * (pMax - pMin);
    //console.log('Listado Estados Sumarizados  - funcion pixel start: ', actualPixelEnd);

    var widhStatus = actualPixelEnd - actualPixelStart;
    //console.log('Listado Estados Sumarizados  - funcion pixel ancho: ', widhStatus);

    return { pixelPosition: actualPixelStart, statusWidth: widhStatus };
  };
  const transformTimelineDataOld = (
    pMin,
    pMax,
    tMin,
    tMax,
    actualTimeStart,
    actualTimeEnd,
  ) => {
    //console.log('Listado Estados Sumarizados  - funcion');
    var tMinValAux = checkZinDateString(tMin);
    var tMaxValAux = checkZinDateString(tMax);
    var timeStartAux = checkZinDateString(actualTimeStart);
    var timeEndAux = checkZinDateString(actualTimeEnd);

    var tMinVal = new Date(tMinValAux).getTime();
    var tMaxVal = new Date(tMaxValAux).getTime();
    var timeStart = new Date(timeStartAux).getTime();
    var timeEnd = new Date(timeEndAux).getTime();

    var tNumStart = timeStart - tMinVal;
    var tDenStart = tMaxVal - tMinVal;
    var tDivStart = tNumStart / tDenStart;
    var actualPixelStart = pMin + tDivStart * (pMax - pMin);
    //console.log('Listado Estados Sumarizados  - funcion pixel start: ', actualPixelStart);

    var tNumEnd = timeEnd - tMinVal;
    var tDenEnd = tMaxVal - tMinVal;
    var tDivEnd = tNumEnd / tDenEnd;
    var actualPixelEnd = pMin + tDivEnd * (pMax - pMin);
    //console.log('Listado Estados Sumarizados  - funcion pixel start: ', actualPixelEnd);

    var widhStatus = actualPixelEnd - actualPixelStart;
    //console.log('Listado Estados Sumarizados  - funcion pixel ancho: ', widhStatus);

    return { pixelPosition: actualPixelStart, statusWidth: widhStatus };
  };

  const handleMouseEnterTrackSvg = (e, info) => {
    const rect = e.target.getBoundingClientRect();
    //console.log("mouse entro ", rect);
    //console.log("mouse entro ", info);
    var posX = rect.x + rect.width / 2;
    if (posX < 100) {
      posX = posX + 60;
    }
    if (posX > 200) {
      posX = posX - 60;
    }

    var initial_datetime = info?.initial_datetime;
    var end_datetime = info?.end_datetime;
    const start = new Date(initial_datetime);
    const end = new Date(end_datetime);
    const diffMs = end - start;
    const diffMinutesAux = diffMs / (1000 * 60);
    const diffMinutes = Math.round(diffMinutesAux);

    setTRTimelineTracksTooltip({
      visible: true,
      x: posX,
      y: rect.y - 10,
      status: info?.last_status,
      initialDatetime: initial_datetime,
      endDatetime: end_datetime,
      duration: diffMinutes,
    });
  };

  const handleMouseLeaveTrackSvg = () => {
    //console.log("mouse salio ");
    setTRTimelineTracksTooltip({
      visible: false,
      x: 0,
      y: 0,
      status: "",
      initialDatetime: "",
      endDatetime: "",
      duration: "",
    });
  };

  const handleMouseEnterTrackTUMSvg = (e, info) => {
    const rect = e.target.getBoundingClientRect();
    //console.log("mouse entro ", rect.x);
    //console.log("mouse entro ", rect.width);
    //console.log("mouse entro ", info);

    var posX = rect.x + rect.width / 2;
    if (posX < 100) {
      posX = posX + 60;
    }
    if (posX > 200) {
      posX = posX - 60;
    }

    var initial_datetime = info?.initial_date;
    var end_datetime = info?.end_date;

    var initial_datetime_aux = initial_datetime.replace(".000Z", "");
    var initial_date = initial_datetime_aux.replace(".000", "");

    var end_datetime_aux = end_datetime.replace(".000Z", "");
    var end_date = end_datetime_aux.replace(".000", "");

    const start = new Date(initial_date);
    const end = new Date(end_date);
    const diffMs = end - start;
    const diffMinutesAux = diffMs / (1000 * 60);
    const diffMinutes = Math.round(diffMinutesAux);

    setTRTimelineTumTooltip({
      visible: true,
      x: posX,
      y: rect.y - 10,
      status: info?.status,
      category: info?.category,
      subCategory: "",
      reason: info?.reason_name,
      initialDatetime: initial_date,
      endDatetime: end_date,
      duration: diffMinutes,
    });
  };

  const handleMouseLeaveTrackTumSvg = () => {
    //console.log("mouse salio ");
    setTRTimelineTumTooltip({
      visible: false,
      x: 0,
      y: 0,
      status: "",
      category: "",
      subCategory: "",
      reason: "",
      initialDatetime: "",
      endDatetime: "",
      duration: "",
    });
  };
  const handleClickShowLabel = () => {
    //console.log("Se cambia el label");
    setmapControlLabels(!mapControlLabels);
  };

  const handleClickShowEquipment = () => {
    setTrackReplayShowEquipmentMap(!trackReplayShowEquipmentMap);
  };

  const handleSelectEquipment = async (selectedOption) => {
    if (selectedOption.length <= 3) {
      setTrackReplayEquipmentSelected(selectedOption);
    } else {
      let result_error = await Swal.fire({
        title: "Limit of selected equipment",
        icon: "warning",
        text: "Currently, you can manage a maximum of 3 equipment items",
        confirmButtonColor: "#3085d6",
        customClass: {
          confirmButton:
            "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
        },
        buttonsStyling: false,
      });
    }
  };
  function MapStyleControl({ onChange, mapStylesList }) {
    useControl(
      () => {
        class StyleControl {
          onAdd() {
            this._container = document.createElement("div");
            this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
            this._container.style.display = "flex";
            this._container.style.flexDirection = "column";
            this._container.style.padding = "2px";

            const selectComponent = document.createElement("select");
            mapStylesList.forEach((style) => {
              const optionElement = document.createElement("option");
              optionElement.value = style.value;
              optionElement.textContent = style.label;

              if (style.value === mapControlType.value) {
                optionElement.selected = true;
              }
              selectComponent.appendChild(optionElement);
            });

            selectComponent.onchange = (e) => {
              //console.log('El tipo de mapa es ', e.target.value)
              //console.log('El tipo de mapa es',  e.target.textContent)
              onChange({ label: e.target.textContent, value: e.target.value });
            };
            this._container.appendChild(selectComponent);

            return this._container;
          }

          onRemove() {
            this._container.remove();
          }
        }
        return new StyleControl();
      },
      { position: "top-left" },
    );

    return null;
  }

  function MapLabelControl({ onToggle }) {
    useControl(
      () => {
        class ToggleControl {
          onAdd(map) {
            this._map = map;

            // contenedor esperado por Mapbox
            this._container = document.createElement("div");
            this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";

            // botón
            this._btn = document.createElement("button");
            this._btn.type = "button";
            this._btn.title = "show";
            this._btn.innerHTML = "📍";
            this._btn.style.background = "#fff";
            this._btn.style.border = "none";
            this._btn.style.cursor = "pointer";
            this._btn.style.fontSize = "18px";
            this._btn.style.padding = "6px";
            this._btn.style.borderRadius = "4px";

            // handler guardado para poder removerlo luego
            this._handler = (e) => {
              e.stopPropagation();
              e.preventDefault();
              //console.log("Toggle control clicked"); // línea de depuración
              try {
                onToggle();
              } catch (err) {
                //console.error("Error en onToggle:", err);
                var aux_err = 0;
              }
            };

            this._btn.addEventListener("click", this._handler);

            this._container.appendChild(this._btn);
            return this._container;
          }

          onRemove() {
            if (this._btn && this._handler) {
              this._btn.removeEventListener("click", this._handler);
            }
            if (this._container && this._container.parentNode) {
              this._container.parentNode.removeChild(this._container);
            }
            this._map = undefined;
          }
        }

        return new ToggleControl();
      },
      { position: "top-right" },
    );
    return null;
  }

  return (
    <div
      className={`flex flex-col w-full h-[calc(100vh-4.8rem)]  mt-14 ${
        isFooterOpen ? "pb-8" : ""
      }`}
    >
      <div className={`flex flex-row w-full h-full`}>
        {/*Contenedor de equipos*/}
        {showEquipmentInfo && actualInfoGps && (
          <div
            className={`flex-none basis-[32%] w-[32%] min-w-0 h-full z-0 bg-gray-300 flex flex-col border-r-4`}
          >
            <div className="flex items-center justify-center">
              <h4 className="text-center text-2xl font-bold dark:text-black p-2 col-1">
                Equipment
              </h4>
              <button
                className="bg-blue-600 rounded-md p-0.5 mt-1 px-2"
                onClick={handleClickShowEquipment}
              >
                {" "}
                <img
                  src={trackReplayShowEquipmentMap ? eyeOpen : eyeClose}
                  alt="Mi Logo SVG"
                  width="20"
                  height="20"
                />
              </button>
            </div>

            <div className="flex flex-col flex-1 min-h-0">
              {/* Div superior (70%) */}
              <div className="flex-[7] min-h-0 overflow-hidden">
                <EquipmentTable
                  rowInfo={actualInfoGps}
                  appUnit={applicationInfo?.app_unit}
                  equipmentClick={equipmentClick}
                />
              </div>

              {/* Div inferior (30%) */}
              <div
                className="bg-gray-400 cursor-pointer mt-1"
                onClick={handleMinimizeTrackReplay}
              >
                <p
                  className="text-sm text-right text-white font-bold mr-3"
                  border-t
                >
                  {TRActionMinimize ? "▲" : " ▼"}
                </p>
              </div>
              {TRActionMinimize == false && (
                <div className="flex-[3] border-t p-2 bg-gray-300">
                  <div className="flex flex-col flex-1 min-h-0">
                    {/* Se debe crear div para filtro y botones cambio de tabla */}
                    <div className="min-h-0 overflow-visible">
                      <div class="grid grid-cols-7 gap-4">
                        <div class="col-span-4">
                          <Select
                            value={trackReplayEquipmentSelected}
                            onChange={handleSelectEquipment}
                            options={trackReplayEquipmentList}
                            className="text-xs"
                            isMulti
                            styles={customStylesSelectTrackReplay}
                          />
                        </div>
                        <div class="col-span-1">
                          <div class="inline-flex">
                            <button
                              className="bg-transparent text-xs hover:bg-blue-500 text-blue-700 font-semibold hover:text-white 
                              py-1 px-3 border border-blue-500 hover:border-transparent rounded  mr-1"
                              onClick={handleTrackReplayButtom}
                            >
                              Replay
                            </button>
                            <button
                              class="bg-transparent text-xs hover:bg-blue-500 text-blue-700 font-semibold hover:text-white 
                                     py-1 px-4 border border-blue-500 hover:border-transparent rounded px-2 mr-1"
                              onClick={handleTrackPointButtom}
                            >
                              Tracks
                            </button>

                            {/* applicationInfo &&
                              applicationInfo?.app_has_tum_replay && (
                                <button
                                  class="bg-transparent text-xs hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-1 px-4 border border-blue-500 hover:border-transparent rounded px-2"
                                  onClick={handleTumButtom}
                                >
                                  TUM
                                </button>
                              )*/}
                            <p className="ml-2">
                              {trackReplayRefreshIcon ? "🕘" : ""}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-3 gap-4 mt-1 mb-1 items-center">
                        {/* Fecha desde / hasta */}
                        <div className="col-span-2 flex items-center gap-2">
                          <DatePicker
                            selected={trackReplayStartDate}
                            onChange={(date) => setTrackReplayStartDate(date)}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="MMM-dd-yyyy HH:mm"
                            placeholderText="MM-DD-YYYY HH:mm"
                            className="w-full border border-gray-300 rounded-sm px-2 py-1.5 text-xs"
                            wrapperClassName="w-full"
                            popperPlacement="bottom-end"
                            popperClassName="datepicker-elevado"
                            portalId="root"
                          />

                          <DatePicker
                            selected={trackReplayEndDate}
                            onChange={(date) => setTrackReplayEndDate(date)}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="MMM-dd-yyyy HH:mm"
                            placeholderText="MM-DD-YYYY HH:mm"
                            className="w-full border border-gray-300 rounded-sm px-2 py-1.5 text-xs"
                            wrapperClassName="w-full"
                            popperPlacement="bottom-start"
                            popperClassName="datepicker-elevado"
                            portalId="root"
                          />
                        </div>

                        {/* Botones */}
                        <div className="col-span-1 ">
                          <div className="inline-flex">
                            <button
                              className="bg-transparent text-xs hover:bg-blue-500 text-blue-700 font-semibold hover:text-white 
                py-1 px-4 border border-blue-500 hover:border-transparent rounded  mr-1"
                              onClick={fetchTrackerInfo}
                            >
                              Show
                            </button>
                            <button
                              className="bg-transparent text-xs hover:bg-blue-500 text-blue-700 font-semibold hover:text-white 
                py-1 px-4 border border-blue-500 hover:border-transparent rounded"
                              onClick={cleanReplayInfo}
                            >
                              Clean
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Aquí va Van dos div uno visible y otro que queda desmontado(esto va cambiando con los botones) */}
                    {trackReplayShowReplay && (
                      <div class="grid grid-flow-col grid-rows-10 flex-1 ">
                        <div
                          class="row-span-8 bg-white relative p-1 overflow-y-auto"
                          style={{ height: 197 }}
                        >
                          <input
                            type="range"
                            id="range"
                            min={TRTimelineInitialDateUnix}
                            max={TRTimelineEndDateUnix}
                            value={TRActionActualTimeUnix}
                            step={1000}
                            className="h-3 bg-gray-200 rounded-lg appearance-none"
                            onChange={trackReplaySliderByTime}
                            style={{ width: TRActionDivRefSvgSize.width + 8 }}
                          />
                          <svg
                            ref={TRActionDivRefSvg}
                            width="98%"
                            height={50 * TRTimelineTracks.length + 20}
                          >
                            {trackpointInfoGps?.length > 0 && (
                              <>
                                <rect
                                  text
                                  x={TRTimelinePositionRec.xPos - 20}
                                  y={1}
                                  fill="black"
                                  width={40}
                                  height={18}
                                  rx={4}
                                  ry={4}
                                />
                                <text
                                  x={TRTimelinePositionRec.xPos - 16}
                                  y={13}
                                  fill="white"
                                  fontSize={9}
                                >
                                  {TRActionActualTimeUnixString}
                                </text>
                                <rect
                                  text
                                  x={TRTimelinePositionRec.xPos}
                                  y={20}
                                  width={1}
                                  height={100 * TRTimelineTracks.length + 20}
                                />
                              </>
                            )}

                            {trackpointInfoGps?.length > 0 &&
                              TRTimelineInitialDate &&
                              TRTimelineEndDate &&
                              TRTimelineTracks.map(
                                (trackByEquipment, index) => (
                                  <>
                                    <TrackReplaySVGTrack
                                      timelineInitialDate={
                                        TRTimelineInitialDateUnix
                                      }
                                      timelineEndDate={TRTimelineEndDateUnix}
                                      timeLineTrack={
                                        trackByEquipment?.track_timeline
                                      }
                                      widthAux={TRActionDivRefSvgSize.width}
                                      handleMouseEnterTrackSvg={
                                        handleMouseEnterTrackSvg
                                      }
                                      handleMouseLeaveTrackSvg={
                                        handleMouseLeaveTrackSvg
                                      }
                                      transformTimelineData={
                                        transformTimelineData
                                      }
                                      newPositionY={50 * (index + 1)}
                                      nameReplay={trackByEquipment?.name}
                                      colorReplay={trackByEquipment?.color}
                                    />
                                  </>
                                ),
                              )}
                          </svg>
                          {TRTimelineTracksTooltip.visible && (
                            <div
                              className="fixed bg-black/75 text-white px-2 py-1 rounded text-xs pointer-events-none transform -translate-x-1/2 -translate-y-full"
                              style={{
                                top: TRTimelineTracksTooltip.y,
                                left: TRTimelineTracksTooltip.x,
                              }}
                            >
                              <p>Status: {TRTimelineTracksTooltip.status}</p>
                              <p>
                                Start: {TRTimelineTracksTooltip.initialDatetime}
                              </p>
                              <p>End: {TRTimelineTracksTooltip.endDatetime}</p>
                              <p>
                                Duration: {TRTimelineTracksTooltip.duration}
                              </p>
                            </div>
                          )}
                        </div>
                        <div class="row-span-2 mt-1">
                          <div class="grid grid-cols-1 gap-4">
                            <div class="col-span-1">
                              <div class="inline-flex">
                                <button
                                  className=" text-2xl font-bold py-1 px-1 rounded-l mr-1"
                                  onClick={trackReplayInicioButton}
                                >
                                  ⏮️
                                </button>
                                <button
                                  className="text-2xl font-bold py-1 px-1 rounded-l mr-1"
                                  onClick={trackReplayBackwardButton}
                                >
                                  ⏪
                                </button>
                                <button
                                  className="text-2xl font-bold py-1 px-1 rounded-r mr-1"
                                  onClick={trackReplayPlayButton}
                                >
                                  {TRActionPlay ? "⏸️" : "▶️"}
                                </button>
                                <button
                                  className="text-2xl font-bold py-1 px-1 rounded-r mr-1"
                                  onClick={trackReplayForwardButton}
                                >
                                  ⏩
                                </button>
                                <button
                                  className="text-2xl font-bold py-1 px-1 rounded-r"
                                  onClick={trackReplayEndButton}
                                >
                                  ⏭️
                                </button>
                                <Select
                                  value={TRActionSelectedSpeed}
                                  onChange={(selectedOption) =>
                                    setTRActionSelectedSpeed(selectedOption)
                                  }
                                  options={TRActionSelectListSpeed}
                                  className="text-xs py-1 px-1 mt-1 "
                                  menuPlacement="top"
                                  styles={customStylesSelectTrackReplay}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {applicationInfo &&
                      applicationInfo?.app_has_tum_replay &&
                      trackReplayShowTum && (
                        <div class="grid grid-flow-col grid-rows-4 gap-2 flex-1 ">
                          <div
                            class="row-span-4 bg-white relative p-2 overflow-y-auto mb-4"
                            style={{ height: 250 }}
                          >
                            <svg
                              ref={TRActionDivRefSvg}
                              width="100%"
                              height={70 * 4 + 20}
                            >
                              {TRTimelineTracks?.length > 0 &&
                                TRTimelineInitialDate &&
                                TRTimelineEndDate && (
                                  <>
                                    <TrackReplaySVGTrack
                                      timelineInitialDate={
                                        TRTimelineInitialDate
                                      }
                                      timelineEndDate={TRTimelineEndDate}
                                      timeLineTrack={TRTimelineTracks}
                                      widthAux={TRActionDivRefSvgSize.width}
                                      handleMouseEnterTrackSvg={
                                        handleMouseEnterTrackSvg
                                      }
                                      handleMouseLeaveTrackSvg={
                                        handleMouseLeaveTrackSvg
                                      }
                                      transformTimelineData={
                                        transformTimelineData
                                      }
                                    />
                                  </>
                                )}

                              {TRTimelineTum?.length > 0 &&
                                TRTimelineInitialDate &&
                                TRTimelineEndDate && (
                                  <>
                                    <TrackReplaySVGTum
                                      timelineInitialDate={
                                        TRTimelineInitialDate
                                      }
                                      timelineEndDate={TRTimelineEndDate}
                                      timeLineTum={TRTimelineTum}
                                      widthAux={TRActionDivRefSvgSize.width}
                                      handleMouseEnterTrackTUMSvg={
                                        handleMouseEnterTrackTUMSvg
                                      }
                                      handleMouseLeaveTrackTumSvg={
                                        handleMouseLeaveTrackTumSvg
                                      }
                                      transformTimelineData={
                                        transformTimelineData
                                      }
                                    />
                                  </>
                                )}
                              <rect
                                x="0"
                                y="10"
                                width="1"
                                height="98%"
                                rx="2"
                                ry="2"
                                fill="black"
                              />
                              <rect
                                x={TRActionDivRefSvgSize.width - 1}
                                y="10"
                                width="1"
                                height="98%"
                                rx="2"
                                ry="2"
                                fill="black"
                              />
                            </svg>

                            {TRTimelineTracksTooltip.visible && (
                              <div
                                className="fixed bg-black/75 text-white px-2 py-1 rounded text-xs pointer-events-none transform -translate-x-1/2 -translate-y-full"
                                style={{
                                  top: TRTimelineTracksTooltip.y,
                                  left: TRTimelineTracksTooltip.x,
                                }}
                              >
                                <p>Status: {TRTimelineTracksTooltip.status}</p>
                                <p>
                                  Start:{" "}
                                  {TRTimelineTracksTooltip.initialDatetime}
                                </p>
                                <p>
                                  End: {TRTimelineTracksTooltip.endDatetime}
                                </p>
                                <p>
                                  Duration: {TRTimelineTracksTooltip.duration}
                                </p>
                              </div>
                            )}

                            {TRTimelineTumTooltip.visible && (
                              <div
                                className="fixed bg-black/75 text-white px-2 py-1 rounded text-xs pointer-events-none transform -translate-x-1/2 -translate-y-full"
                                style={{
                                  top: TRTimelineTumTooltip.y,
                                  left: TRTimelineTumTooltip.x,
                                }}
                              >
                                <p>Status: {TRTimelineTumTooltip.status}</p>
                                <p>Category: {TRTimelineTumTooltip.category}</p>
                                <p>Reason: {TRTimelineTumTooltip.reason}</p>
                                <p>
                                  Start: {TRTimelineTumTooltip.initialDatetime}
                                </p>
                                <p>End: {TRTimelineTumTooltip.endDatetime}</p>
                                <p>Duration: {TRTimelineTumTooltip.duration}</p>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                    {trackReplayShowTable && (
                      <div className="grid grid-flow-col grid-rows-4 gap-2 flex-1">
                        <div class="row-span-4 bg-white relative p-2 mt-2 mb-1 w-full">
                          {trackpointInfoGps?.length > 0 && (
                            <VirtualizedTable
                              data={trackReplayTableInfo ?? []}
                              columns={trackpointInfoGps[0].columns ?? []}
                              setChangePointMarker={setTrackReplayTableMarker}
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {showGeofenceInfo && actualInfoGps && (
          <div
            className={`flex-none basis-[32%] w-[32%] min-w-0 h-full z-0 bg-gray-300 flex flex-col border-r-4`}
          >
            <div className="grid grid-cols-3 gap-4 pt-2">
              <div></div>
              <div onClick={handleClickShowLabel}>
                <h4 className="text-center text-xl font-bold dark:text-black cursor-pointer">
                  Geofences {geofenceRefreshIcon ? "🕘" : ""}
                </h4>
              </div>
              <div className="flex items-center justify-end mt-1 mb-1">
                {isDrawLoaded && (
                  <button
                    className=" bg-green-600 hover:bg-green-500 text-xs text-white font-semibold p-2"
                    onClick={activeNewGeofence}
                  >
                    + Geofence
                  </button>
                )}
              </div>
            </div>
            <div className="flex flex-col overflow-y-auto min-w-0 ">
              {geofenceList?.length > 0 && (
                <ul className="list-none space-y-1 px-2">
                  {geofenceList.map((geo_group, index) => (
                    <div className="">
                      <li
                        key={geo_group.id ?? index}
                        className="min-h-16 p-2 border-4 border-gray-200"
                      >
                        <div className="flex justify-between text-sm">
                          <p>{geo_group.groupName}</p>
                          <p
                            onClick={() => {
                              UpdateVisibilityGeoGroup(geo_group);
                            }}
                            className={` ${
                              geo_group.isVisible
                                ? "text-blue-600"
                                : "text-orange-600"
                            } text-xs cursor-pointer`}
                          >
                            {" "}
                            {geo_group.isVisible ? "Hidden" : "Show"}
                          </p>
                        </div>
                        <div className="overflow-y-auto flex w-full min-w-0 max-h-24 mt-2">
                          <ul className="flex flex-wrap  min-w-0">
                            {geo_group.geofences?.map((geofence) => (
                              <li key={geofence.name}>
                                <button
                                  class="bg-white hover:bg-gray-200 text-xs text-gray-800 font-semibold py-1 px-2 mr-2 mb-2 whitespace-nowrap rounded-md"
                                  onClick={(e) =>
                                    GeofenceClick(e, geofence, geo_group, 15)
                                  }
                                  onContextMenu={(e) => {
                                    e.preventDefault();
                                    GeofenceClick(e, geofence, geo_group, 15);
                                  }}
                                >
                                  {geofence.name}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    </div>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}
        {/*Contenedor de mapa*/}
        <div className="flex-1 min-w-0 h-full z-0 overflow-hidden">
          {showModalGeofences && (
            <MapGeofenceModal
              title={"New Geofence"}
              modalIsClose={setShowModalGeofences}
              geoGroupList={geofenceSelectList}
              drawRef={drawRef}
              newPolygon={newGeofencePolygon}
              setNewPolygon={setNewGeofencePolygon}
              refreshGeofence={flagRefreshGeofences}
              setRefreshGeofence={setFlagRefreshGeofences}
              appGpsId={applicationInfo?.app_gps_id}
            />
          )}

          {showModalEditGeofences && (
            <MapEditGeofenceModal
              key={geofenceEditPolygonInfo.geofenceId}
              title={"Update Geofence"}
              modalIsClose={setShowModalEditGeofences}
              geoGroupList={geofenceSelectList}
              drawRef={drawRef}
              newPolygon={newGeofencePolygon}
              setNewPolygon={setNewGeofencePolygon}
              refreshGeofence={flagRefreshGeofences}
              setRefreshGeofence={setFlagRefreshGeofences}
              geofenceInfo={geofenceEditPolygonInfo}
              appGpsId={applicationInfo?.app_gps_id}
            />
          )}

          <Map
            ref={mapRef}
            mapboxAccessToken="pk.eyJ1Ijoic2FtdWVsLWJ1c3RvcyIsImEiOiJjbWE0N2RiYTgwMmN2Mndwb2loanRqZXZqIn0.Yr8BttgFAacNXp_0se0HGg"
            initialViewState={{
              longitude: initialPosition.longitude,
              latitude: initialPosition.latitude,
              zoom: initialPosition.zoom,
            }}
            mapStyle={mapControlType.value}
            style={{ width: "100%", height: "100%" }}
          >
            {applicationInfo?.app_has_own_map && (
              <div>
                <Source
                  id="myTileset"
                  type="raster"
                  url={applicationInfo?.app_own_map_tile}
                  tileSize={256}
                />
                <Layer id="myTilesetLayer" type="raster" source="myTileset" />
              </div>
            )}

            <NavigationControl position="top-right" />
            <FullscreenControl position="top-right" />

            {actualInfoGps.length > 0 &&
              trackReplayShowEquipmentMap &&
              actualInfoGps.map((item) => (
                <GpsPositionMarker
                  coordinates={item.trackPoint}
                  markerName={item.name}
                  angle={item.velocity.heading}
                  equipmentType={item.typeEquipment}
                />
              ))}

              {actualInfoGps.length > 0 &&
              trackReplayShowEquipmentMap &&
              actualInfoGps
              .filter((item) => ['25003', '25002'].includes(item.name))
              .map((item) => (
                 <GpsCircle
                  name={item.name}
                  id={item.name}
                  colour={'#5B59FF'}
                  coordinates_circle={{center:{latitude: item.trackPoint.latitude, longitude: item.trackPoint.longitude},
                                      radius:15}}
                  showLabel={false}
                  />
              ))}

            {trackpointInfoGps?.length > 0 &&
              trackpointInfoGps.map((track) => (
                <GpsPositionTrackUnix
                  coordinates={track.trackPoint}
                  width={3}
                  isShow={true}
                  color={track.color}
                  equipmentName={track.name}
                  showMarker={trackReplayShowMarkerReplay}
                  actualTimeUnix={TRActionActualTimeUnix}
                />
              ))}
            {trackReplayTableMarker && (
              <GPSTrackPositionMarker
                coordinates={trackReplayTableMarker}
                markerName={trackReplayTableMarker.name}
              />
            )}

            {/*trackReplayShowTum &&
              TRTimelineTracks?.length > 0 &&
              TRTimelineTracks.map((track) => (
                <GpsPositionTrackTum
                  coordinates={track?.trackpoint_list}
                  color={track.colour}
                  width={5}
                  id={track.initial_datetime}
                />
              ))*/}

            {geofenceList?.length > 0 &&
              geofenceList.map((geo_group) =>
                geo_group.geofences?.map((geofence) => (
                  <>
                    {geo_group.isVisible && geofence.type === "Polygon" && (
                      <GpsPolygon
                        key={`polygon-${geofence.id}`}
                        id={geofence.id}
                        name={geofence.name}
                        colour={geo_group.colour}
                        coordinates_polygon={geofence.vertices}
                        showLabel={mapControlLabels}
                        geofenceDescription={geofence.description}
                        geogroupId={geo_group.groupId}
                        geogroupName={geo_group.groupName}
                        setShowModal={activeEditGeofence}
                        setGeofenceEditPolygonInfo={setGeofenceEditPolygonInfo}
                      />
                    )}
                    {geo_group.isVisible && geofence.type === "Circle" && (
                      <GpsCircle
                        key={`circle-${geofence.id}`}
                        id={geofence.id}
                        name={geofence.name}
                        colour={geo_group.colour}
                        coordinates_circle={geofence.circleConfig}
                        showLabel={mapControlLabels}
                      />
                    )}
                  </>
                )),
              )}

            <ScaleControl
              unit={`${
                applicationInfo?.app_unit ? applicationInfo?.app_unit : "metric"
              }`}
              position="bottom-right"
            />
            <MapStyleControl
              onChange={setmapControlType}
              mapStylesList={mapboxStyles}
            />
          </Map>
        </div>
      </div>
    </div>
  );
};

export default MainMapContainer;
